export interface WeekNavVariantProps {
  currentWeekStart: Date;
  status: string;
  isViewingOtherResource: boolean;
  canNavigatePrev: boolean;
  canNavigateNext: boolean;
  minAllowedDate: Date;
  maxAllowedDate: Date | undefined;
  onNavigate: (direction: 'prev' | 'next') => void;
  onNavigateToDate: (date: Date) => void;
}

export const VIEWING_OTHER_RESOURCE_TITLE =
  "Week navigation is disabled when viewing another resource's timesheet from a report";
